import ServiceCategoryPage from "../components/ServiceCategoryPage";
import laptopBasicSupportService from "../data/services/laptopBasicSupportService";

function LaptopBasicSupport() {
  return <ServiceCategoryPage service={laptopBasicSupportService} />;
}

export default LaptopBasicSupport;